<template>
  <div class="flex flex-row flex-grow space-x-10 px-10 h-full">
    <div class="py-10 flex flex-grow flex-col space-y-20 overflow-y-auto">
      <h1 class="text-24px leading-24px font-bold">{{ title }}</h1>

      <div class="flex flex-col flex-grow items-start justify-center max-w-lg space-y-6">
        <img src="@/assets/icons/done.svg" alt="">

        <b class="text-22px leading-26px font-bold">
          {{ headline }}
        </b>

        <span class="text-16px leading-24px text-inverse">
          {{ description }}
        </span>

        <div
          v-if="demandText"
          class="rounded-lg border border-geyser bg-white p-5 text-14px leading-20px text-muted">
          {{ demandText }}
        </div>
      </div>
    </div>

    <div class="hidden lg:flex flex-row items-stretch py-10 space-x-12">
      <div class="w-72 rounded-lg overflow-hidden">
        <img
          class="h-full object-center object-cover w-full"
          src="@/assets/images/poster-2.png"
          alt="iWALY">
      </div>
      <div class="w-72 rounded-lg overflow-hidden">
        <img
          class="h-full object-center object-cover w-full"
          src="@/assets/images/poster-1.png"
          alt="iWALY">
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      payload: (state) => state.payload,
    }),

    isApplicationReview() {
      return this.payload && this.payload.applicationSubmissionMode === 'application_review_reserve';
    },

    title() {
      return this.isApplicationReview
        ? 'Заявка отправлена'
        : 'Регистрация успешно завершена';
    },

    headline() {
      if (this.isApplicationReview) {
        return 'Спасибо! Мы получили вашу заявку и рассмотрим её вручную.';
      }

      return 'На почту, указанную при регистрации, отправлено письмо для прохождения верификации.';
    },

    description() {
      if (this.isApplicationReview) {
        return 'По коммерческим направлениям мы не создаём аккаунт автоматически: сначала проверяем регион, категории, текущую потребность и баланс исполнителей. Мы молодой сервис, поэтому заказов может быть мало или какое-то время не быть совсем. Будем рады сотрудничеству в резервном формате и помощи в информировании заинтересованных людей.';
      }

      return 'Пожалуйста, подтвердите почту и ожидайте активации вашего партнёрского аккаунта. Для категории «Помощь волонтёров» подключение возможно автоматически, но это новый формат без гарантии потока заказов.';
    },

    demandText() {
      const signal = this.payload ? this.payload.demandSignal : '';
      const comment = this.payload ? this.payload.demandComment : '';

      if (!signal && !comment) {
        return '';
      }

      return `Статус спроса по выбранному региону/категориям: ${signal || 'ручная проверка'}. ${comment || ''}`;
    },
  },
};
</script>
